module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_13-4da51dcf511838a6f3f33cabdd1d09b7.jpg";